import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { useEffect, useState, useRef } from 'react';
import RawMaterialService from '../../services/RawMaterials/RawMaterialService';
import posService from '../../services/pos/pos.service';
import { Toast } from 'primereact/toast';

interface RawMaterialsSearchProps {
  onSearch: (filters: {
    rawMaterialId?: number;
    supplierId?: number;
    rmCategoryId?: number;
    activeOnly?: boolean;
    startDate?: string;
    endDate?: string;
    keyword?: string;
    invoiceNumber?: string;
    posId?: number;
    posAlias?: string;
  }) => void;
  onReset: () => void;
  totalRecords: number;
}

const RawMaterialsSearch: React.FC<RawMaterialsSearchProps> = ({
  onSearch,
  onReset,
  totalRecords
}) => {
  const [MaterialId, setMaterialId] = useState<number | null>(null);
  const [Rawmaterials, setRawmaterials] = useState<any[]>([]);
  const [category, setcategory] = useState<any[]>([]);
  const [categoryId, setcategoryId] = useState<number | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [filterApplied, setFilterApplied] = useState(false);
  const [keyword, setKeyword] = useState<string>("");
  const toast = useRef<Toast>(null);
  const [InvoiceNos, setInvoiceNos] = useState<{ invoiceNumber: string }[]>([]);
  const [selectedInvoiceNo, setSelectedInvoiceNo] = useState<string | null>(null);
  const [posList, setPosList] = useState<any[]>([]);
  const [selectedPosId, setSelectedPosId] = useState<number | null>(null);
  const [hidePosDropdown, setHidePosDropdown] = useState(false);
  const onSearchRef = useRef(onSearch);

  onSearchRef.current = onSearch;

  const resolvePosAlias = (mu: any) => {
    const posId = Number(mu.posID ?? mu.posId);
    const posCode = String(mu.posCode ?? mu.PosCode ?? mu.POSCode ?? "").trim().toUpperCase();
    const directAlias = String(
      mu.posAlias ?? mu.POSAlias ?? mu.PosAlias ?? mu.pos_alias ?? ""
    ).trim();

    if (directAlias) return directAlias;
    if (posId === 1 || posCode === "POS-001") return "NGBV";
    if (posId === 2 || posCode === "POS-002") return "MYS";
    if (posId === 3 || posCode === "POS-003" || posCode === "KRN1") return "KRN1";
    if (posId === 4 || posCode === "POS-004" || posCode === "MGT") return "MGT";
    if (posId === 5 || posCode === "POS-005" || posCode === "KRN2") return "KRN2";
    if (posId === 6 || posCode === "POS-006" || posCode === "NGBV2") return "NGBV2";
    return posCode || `Unit-${posId}`;
  };

  useEffect(() => {
    const fetchRawMaterials = async () => {
      try {
        const response = await RawMaterialService.getRawMaterials();
        console.log("ðŸ” Raw Materials Response:", response);
        console.log("ðŸ” First Item:", response?.[0]);
        setRawmaterials(response || []);
      } catch (error) {
        console.error("Error fetching raw materials:", error);
        setRawmaterials([]);
      }
    };

    const fetchCategories = async () => {
      try {
        const response = await RawMaterialService.RMCategories();
        setcategory(response || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setcategory([]);
      }
    };

    const formatPOSLabel = (mu: any) => {
      const posCode = mu.posCode?.trim();
      const posId = Number(mu.posID ?? mu.posId);
      const directAlias = (mu.posAlias || mu.POSAlias || mu.PosAlias || mu.pos_alias || "")?.trim();

      const posAlias =
        directAlias ||
        (posId === 1 || posCode === "POS-001"
          ? "NGBV"
          : posId === 2 || posCode === "POS-002"
          ? "MYS"
          : posId === 3 || posCode === "POS-003" || posCode === "KRN1"
          ? "KRN1"
          : posId === 4 || posCode === "POS-004" || posCode === "MGT"
          ? "MGT"
          : posId === 5 || posCode === "POS-005" || posCode === "KRN2"
          ? "KRN2"
          : posId === 6 || posCode === "POS-006" || posCode === "NGBV2"
          ? "NGBV2"
          : "");

      if (posCode && posAlias) return `${posCode} - ${posAlias}`;
      if (posCode) return posCode;
      return posAlias || `Unit-${mu.posID}`;
    };

    const fetchPosList = async () => {
      try {
        const response = await posService.getAllPOS();
        const mapped = (Array.isArray(response) ? response : []).map((p: any) => ({
          posID: p.posID,
          posAlias: resolvePosAlias(p),
          posCode: p.posCode,
          cityName: p.cityName,
          displayName: formatPOSLabel(p),
        }));
                console.log("✅ POS LIST:", mapped);
        setPosList(mapped);

        if (mapped.length === 1) {
          const defaultPos = mapped[0];
          setHidePosDropdown(true);
          setSelectedPosId(Number(defaultPos.posID));
          onSearchRef.current({
            posId: Number(defaultPos.posID),
            posAlias: defaultPos.posAlias,
          });
          console.log("✅ Single POS user auto filtered");
        } else {
          setHidePosDropdown(false);
        }
      } catch (error) {
        console.error("Error fetching POS list:", error);
        setPosList([]);
      }
    };

    const fetchInvoiceNos = async () => {
      try {
        const response = await RawMaterialService.getInvoicenos();
        console.log("fetchInvoiceNos response:", response);
        setInvoiceNos(response || []);
      } catch (error) {
        console.error("Error fetching invoice numbers:", error);
        setInvoiceNos([]);
      }
    };

    fetchRawMaterials();
    fetchCategories();
    fetchInvoiceNos();
    fetchPosList();
  }, []);

  const formatDateWithoutTimezone = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSearch = () => {
    if (
      !keyword.trim() &&
      !MaterialId &&
      !categoryId &&
      !startDate &&
      !endDate &&
      !selectedInvoiceNo &&
      !selectedPosId
    ) {
      toast.current?.show({
        severity: 'warn',
        summary: 'âš ï¸ Missing Filters',
        detail: 'Please choose at least one filter.',
        life: 4000
      });
      return;
    }

    if (startDate && !endDate) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Missing Date',
        detail: 'Please select an End Date to complete the range.',
        life: 4000
      });
      return;
    }

    if (!startDate && endDate) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Missing Date',
        detail: 'Please select a Start Date to complete the range.',
        life: 4000
      });
      return;
    }

    if (startDate && endDate && endDate < startDate) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'End Date cannot be earlier than Start Date.',
        life: 3000
      });
      return;
    }

    console.log("ðŸ” Manual search with filters:", {
      rawMaterialId: MaterialId,
      rmCategoryId: categoryId,
      keyword: keyword.trim(),
      invoiceNumber: selectedInvoiceNo,
      posId: selectedPosId,
      posAlias: posList.find((p) => Number(p.posID) === Number(selectedPosId))?.posAlias
    });

    onSearch({
      rawMaterialId: MaterialId !== null ? MaterialId : undefined,
      rmCategoryId: categoryId !== null ? categoryId : undefined,
      startDate: startDate ? formatDateWithoutTimezone(startDate) : undefined,
      endDate: endDate ? formatDateWithoutTimezone(endDate) : undefined,
      keyword: keyword || undefined,
      invoiceNumber: selectedInvoiceNo || undefined,
      posId: selectedPosId ?? undefined,
      posAlias: posList.find((p) => Number(p.posID) === Number(selectedPosId))?.posAlias || undefined
    });
    setFilterApplied(true);
  };

  const handleReset = () => {
    setMaterialId(null);
    setcategoryId(null);
    setStartDate(null);
    setEndDate(null);
    setFilterApplied(false);
    setKeyword("");
    setSelectedInvoiceNo(null);
    setSelectedPosId(null);
    onReset();
  };

  return (
    <div className="flex flex-wrap align-items-center justify-content-between gap-3">
      <Toast ref={toast} />

      {/* Keyword Search */}
      <div style={{ flex: '1 1 18%' }}>
        <InputText
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="Search keyword"
          className="w-full"
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch();
          }}
        />
      </div>

      {/* Raw Material Dropdown */}
      <div style={{ flex: '1 1 18%' }}>
        <Dropdown
          id="rawMaterialDropdown"
          value={MaterialId}
          options={Rawmaterials}
          optionLabel="name"
          optionValue="id"
          placeholder="Select RawMaterial"
          onChange={(e) => {
            console.log("ðŸ” Selected Material:", e.value);
            setMaterialId(e.value);
          }}
          className="w-full"
          filter
          filterBy="name"
          showFilterClear
          filterMatchMode="contains"
          filterPlaceholder="Search raw materials..."
          emptyMessage="No raw materials found"
          emptyFilterMessage="No results found"
          showClear
        />
      </div>

      {/* Invoice Number Dropdown */}
      <div style={{ flex: '1 1 18%' }}>
        <Dropdown
          value={selectedInvoiceNo}
          options={InvoiceNos}
          optionLabel="invoiceNumber"
          optionValue="invoiceNumber"
          placeholder="Select InvoiceNumber"
          onChange={(e) => setSelectedInvoiceNo(e.value)}
          className="w-full"
          filter
          filterBy="invoiceNumber"
          showFilterClear
          filterMatchMode="contains"
          emptyMessage="No invoices found"
          emptyFilterMessage="No results found"
        />
      </div>

      {/* Category Dropdown */}
      <div style={{ flex: '1 1 18%' }}>
        <Dropdown
          id="categoryID"
          name="categoryID"
          value={categoryId}
          options={category}
          optionLabel="categoryName"
          optionValue="categoryID"
          placeholder="Select Category"
          onChange={(e) => setcategoryId(e.value)}
          className="w-full"
          filter
          filterBy="categoryName"
          filterMatchMode="contains"
          showFilterClear
          emptyMessage="No categories found"
          emptyFilterMessage="No results found"
        />
      </div>

      {/* Manufacturing Unit Dropdown */}
      {!hidePosDropdown && (
        <div style={{ flex: '1 1 18%' }}>
          <Dropdown
            value={selectedPosId}
            options={posList}
            optionLabel="displayName"
            optionValue="posID"
            placeholder="Select Unit"
            onChange={(e) => {
              const value = e.value == null ? null : Number(e.value);
              setSelectedPosId(value);
              if (value == null) {
                onSearch({});
                return;
              }
              const selectedPos = posList.find((p) => Number(p.posID) === value);
              onSearch({
                posId: value,
                posAlias: selectedPos?.posAlias,
              });
            }}
            className="w-full"
            filter
            filterBy="displayName,posAlias,posCode"
            filterMatchMode="contains"
            showClear
            emptyMessage="No units found"
            emptyFilterMessage="No results found"
          />
        </div>
      )}

      {/* Date Range and Buttons */}
      <div className="flex flex-wrap gap-3 w-full mt-2">
        <div style={{ flex: "1 1 11%" }}>
          <Calendar
            value={startDate}
            onChange={(e) => setStartDate(e.value as Date)}
            placeholder="Start Date"
            dateFormat="dd-mm-yy"
            readOnlyInput
            inputRef={(el) => {
              if (el) el.readOnly = true;
            }}
            className="w-full"
            showButtonBar
          />
        </div>

        <div style={{ flex: "1 1 11%" }}>
          <Calendar
            value={endDate}
            onChange={(e) => setEndDate(e.value as Date)}
            placeholder="End Date"
            dateFormat="dd-mm-yy"
            readOnlyInput
            inputRef={(el) => {
              if (el) el.readOnly = true;
            }}
            className="w-full"
            showButtonBar
          />
        </div>

        <div style={{ flex: "1 1 20%" }} className="flex gap-2 justify-content-end">
          <Button
            label="Filter"
            className="p-button-success"
            onClick={handleSearch}
            style={{ width: "100px" }}
          />
          <Button
            label="Reset"
            className="text-black border-round p-button-m"
            severity="secondary"
            text
            raised
            onClick={handleReset}
            style={{ width: "100px" }}
          />
        </div>
      </div>

      {filterApplied && (
        <div className="col-12 mt-2 ml-3 text-sm">
          <span className="text-black font-semibold text-lg">
            Number of Raw Materials: {totalRecords}
          </span>
        </div>
      )}
    </div>
  );
};

export default RawMaterialsSearch;


